import { render, staticRenderFns } from "./ajetaktarim.vue?vue&type=template&id=57a89c0c&"
import script from "./ajetaktarim.vue?vue&type=script&lang=js&"
export * from "./ajetaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports